import { imageDirectory } from 'environment'

export const MTG_CARD_BACK = 'https://storage.googleapis.com/archidekt-card-images/magic_card_back.webp'

export type ImageSize = 'small' | 'normal' | 'large' | 'art_crop' | 'png'

const WebpSizeTranslation: Record<ImageSize, string> = {
  'art_crop': 'art',
  'small': 'thumb',
  'normal': 'grid',
  'large': 'display',
  'png': 'png',
}

const SCM_URL = 'https://card-images.archidekt.com'
const SCRY_URL = 'https://cards.scryfall.io'

export const getScryfallImageUrl = (
  uid: string,
  back: boolean,
  size: ImageSize,
  scryfallImageHash?: string | null,
  usePngFileType?: boolean,
) => {
  const cacheBustParameter = scryfallImageHash || '11' // If the scryfall images are ever cached on something wrong, we can bump this up
  const fileType = usePngFileType ? 'png' : 'jpg'

  if (!usePngFileType) return getSCMImageUrl(uid, back, size, scryfallImageHash, usePngFileType)

  if (!size)
    return back
      ? `${SCRY_URL}/normal/back/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
      : `${SCRY_URL}/normal/front/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`

  return back
    ? `${SCRY_URL}/${size}/back/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
    : `${SCRY_URL}/${size}/front/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
}

const getSCMImageUrl = (
  uid: string,
  back: boolean,
  size: ImageSize,
  scryfallImageHash?: string | null,
  usePngFileType?: boolean,
) => {
  const cacheBustParameter = scryfallImageHash || '11' // If the scryfall images are ever cached on something wrong, we can bump this up
  const fileType = usePngFileType ? 'png' : 'webp'
  const actualSize = fileType === 'webp' ? WebpSizeTranslation[size] || 'grid' : 'png'

  if (!size)
    return back
      ? `${SCM_URL}/grid/back/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
      : `${SCM_URL}/grid/front/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`

  return back
    ? `${SCM_URL}/${actualSize}/back/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
    : `${SCM_URL}/${actualSize}/front/${uid.charAt(0)}/${uid.charAt(1)}/${uid}.${fileType}?${cacheBustParameter}`
}

/**
 * Function that builds an images URL of a card given card info.
 *
 * TODO - Just pass in a card here. It doens't make sense to pass in the pieces it just makes everything harder
 * to read.
 */
export const getImageUrl = (setCode: string, uid: string, back: boolean, size?: string): string => {
  if (!size)
    return back
      ? imageDirectory + setCode + '/' + uid + '_small_back.jpg'
      : imageDirectory + setCode + '/' + uid + '_small.jpg'

  return back
    ? imageDirectory + setCode + '/' + uid + '_' + size + '_back.jpg'
    : imageDirectory + setCode + '/' + uid + '_' + size + '.jpg'
}

export const getArtUrl = (setCode: string, uid: string, back?: boolean): string => {
  return `${imageDirectory}${setCode}/${uid}_art_crop${back ? '_back' : ''}.jpg`
}

/**
 * Parses an image url and extracts the uid from the url and returns it.
 */
export const getId = (url: string): string => {
  let id = ''

  if (url && url.includes(imageDirectory)) {
    const split = url.split('/')
    id = split[split.length - 1].split('_')[0]
  }

  return id
}
